import { render } from "./PrintNotes.vue?vue&type=template&id=49067376&scoped=true"
import script from "./PrintNotes.vue?vue&type=script&lang=js"
export * from "./PrintNotes.vue?vue&type=script&lang=js"

import "./PrintNotes.vue?vue&type=style&index=0&id=49067376&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49067376"]])

export default __exports__